import axios from 'axios';
import { API_CONFIG } from './config';

// Create axios instance
const apiClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.DEFAULT_HEADERS,
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// API Service Class
class ApiService {
  // Authentication APIs
  async login(credentials) {
    const response = await apiClient.post(API_CONFIG.ENDPOINTS.LOGIN, credentials);
    return response.data;
  }

  async register(userData) {
    const response = await apiClient.post(API_CONFIG.ENDPOINTS.REGISTER, userData);
    return response.data;
  }

  async logout() {
    const response = await apiClient.post(API_CONFIG.ENDPOINTS.LOGOUT);
    return response.data;
  }

  // Step-wise Booking APIs
  async createBookingStep1(step1Data) {
    const response = await apiClient.post(API_CONFIG.ENDPOINTS.BOOKING_STEP1, step1Data);
    return response.data;
  }

  // async updateBookingStep2(id, step2Data) {
  //   const response = await apiClient.put(API_CONFIG.ENDPOINTS.BOOKING_STEP2(id), step2Data);
  //   return response.data;
  // }
//  async updateBookingStep2(id, step2Data) {
//   const formData = new FormData();

//   Object.keys(step2Data).forEach(key => {
//     if (step2Data[key] !== null && step2Data[key] !== undefined) {
//       formData.append(key, step2Data[key]);
//     }
//   });

//   const response = await apiClient.put(
//     API_CONFIG.ENDPOINTS.BOOKING_STEP2(id),
//     formData,
//     {
//       headers: {
//         "Content-Type": "multipart/form-data"
//       }
//     }
//   );

//   return response.data;
// }
async updateBookingStep2(id, step2Data) {
  const response = await apiClient.put(
    API_CONFIG.ENDPOINTS.BOOKING_STEP2(id),
    step2Data
  );
  return response.data;
}




  // async updateBookingStep3(id, step3Data) {
  //   const response = await apiClient.put(API_CONFIG.ENDPOINTS.BOOKING_STEP3(id), step3Data);
  //   return response.data;
  // }
//  async updateBookingStep3(id, step3Data) {
//   const formData = new FormData();

//   Object.keys(step3Data).forEach(key => {
//     if (step3Data[key] !== null && step3Data[key] !== undefined) {
//       formData.append(key, step3Data[key]);
//     }
//   });

//   const response = await apiClient.put(
//     API_CONFIG.ENDPOINTS.BOOKING_STEP3(id),
//     formData,
//     {
//       headers: {
//         "Content-Type": "multipart/form-data"
//       }
//     }
//   );

//   return response.data;
// }
async updateBookingStep3(id, step3Data) {
  const formData = new FormData();

  Object.keys(step3Data).forEach(key => {
    if (step3Data[key] !== null && step3Data[key] !== undefined) {
      formData.append(key, step3Data[key]);
    }
  });

  const response = await apiClient.post(
    API_CONFIG.ENDPOINTS.BOOKING_STEP3(id),
    formData
  );

  return response.data;
}




  async updateBookingStep4(id, step4Data) {
    const response = await apiClient.put(API_CONFIG.ENDPOINTS.BOOKING_STEP4(id), step4Data);
    return response.data;
  }

  // General Booking APIs
  async getBookings() {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.GET_ALL_BOOKINGS);
    return response.data;
  }

  async getBookingById(id) {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.GET_BOOKING_BY_ID(id));
    return response.data;
  }

  async getBookingsByMobile(mobile) {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.GET_BOOKINGS_BY_MOBILE, {
      params: { mobile }
    });
    return response.data;
  }

  async updateBookingStatus(id, status) {
    const response = await apiClient.patch(
      API_CONFIG.ENDPOINTS.UPDATE_BOOKING_STATUS(id),
      { status }
    );
    return response.data;
  }

  async deleteBooking(id) {
    const response = await apiClient.delete(API_CONFIG.ENDPOINTS.GET_BOOKING_BY_ID(id));
    return response.data;
  }

  // Price List APIs
  async getPriceList() {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.PRICE_LIST);
    return response.data;
  }

  // Scrap Rates API
  async getScrapRates() {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.SCRAP_RATES);
    return response.data;
  }

  async createPriceItem(itemData) {
    const response = await apiClient.post(API_CONFIG.ENDPOINTS.PRICE_LIST, itemData);
    return response.data;
  }

  async updatePriceItem(id, itemData) {
    const response = await apiClient.put(API_CONFIG.ENDPOINTS.PRICE_ITEM(id), itemData);
    return response.data;
  }

  async deletePriceItem(id) {
    const response = await apiClient.delete(API_CONFIG.ENDPOINTS.PRICE_ITEM(id));
    return response.data;
  }

  // User Profile APIs
  async getUserProfile() {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.USER_PROFILE);
    return response.data;
  }

  async updateUserProfile(profileData) {
    const response = await apiClient.put(API_CONFIG.ENDPOINTS.UPDATE_PROFILE, profileData);
    return response.data;
  }

  // Admin APIs
  async getAdminStats() {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.ADMIN_STATS);
    return response.data;
  }

  async getAdminBookings(filters = {}) {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.ADMIN_BOOKINGS, {
      params: filters
    });
    return response.data;
  }

  // Contact Us
  async submitContactForm(contactData) {
    const response = await apiClient.post(API_CONFIG.ENDPOINTS.CONTACT_US, contactData);
    return response.data;
  }
}

// Create and export singleton instance
const apiService = new ApiService();
export default apiService;
